export const RESTART_STATE = 'movilidad/detallespedido/restart_state';
export const SET_MASK = 'movilidad/detallespedido/set-mask';
export const UPDATE_FIELD_FILTER = 'movilidad/detallespedido/update-field-filter';
export const RECEIVE_V_LIST = 'movilidad/detallespedido/receive-v-list';
